// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// function Transactions() {
//   const [transactions, setTransactions] = useState([]);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchTransactions = async () => {
//       const token = localStorage.getItem("token");
//       try {
//         const res = await axios.get(`${API_BASE_URL}/transactions`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         setTransactions(res.data);
//         setError("");
//       } catch (err) {
//         setError(err.response?.data?.error || "Failed to fetch transactions");
//       }
//     };
//     fetchTransactions();
//   }, []);

//   const styles = {
//     container: {
//       padding: "20px",
//       backgroundColor: "#f4f4f9",
//       minHeight: "100vh",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#333",
//       marginBottom: "20px",
//       display: "flex",
//       alignItems: "center",
//     },
//     icon: {
//       fontSize: "28px",
//       marginRight: "8px",
//     },
//     tableContainer: {
//       backgroundColor: "#fff",
//       borderRadius: "8px",
//       boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//       overflow: "hidden",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//     },
//     th: {
//       padding: "12px",
//       textAlign: "left",
//       fontSize: "12px",
//       fontWeight: "600",
//       color: "#666",
//       backgroundColor: "#f8f8f8",
//       borderBottom: "2px solid #e0e0e0",
//       textTransform: "uppercase",
//     },
//     td: {
//       padding: "12px",
//       color: "#333",
//       borderBottom: "1px solid #e0e0e0",
//     },
//     row: {
//       backgroundColor: "#fff",
//     },
//     rowAlternate: {
//       backgroundColor: "#f9f9f9",
//     },
//     rowHover: {
//       backgroundColor: "#f0f0f0",
//     },
//     actionTag: {
//       display: "inline-block",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "12px",
//       fontWeight: "500",
//     },
//     actionSent: {
//       backgroundColor: "#e6f3ff",
//       color: "#1e88e5",
//     },
//     actionReceived: {
//       backgroundColor: "#e6ffed",
//       color: "#2e7d32",
//     },
//     empty: {
//       padding: "40px",
//       textAlign: "center",
//       color: "#666",
//       fontSize: "16px",
//     },
//     error: {
//       marginTop: "15px",
//       color: "#e53e3e",
//       fontSize: "14px",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>
//         <span style={styles.icon}>🔄</span> Transactions
//       </h2>
//       <div style={styles.tableContainer}>
//         <table style={styles.table}>
//           <thead>
//             <tr>
//               <th style={styles.th}>ID</th>
//               <th style={styles.th}>File Name</th>
//               <th style={styles.th}>Action</th>
//               <th style={styles.th}>IP Address</th>
//               <th style={styles.th}>Timestamp</th>
//             </tr>
//           </thead>
//           <tbody>
//             {transactions.length > 0 ? (
//               transactions.map((t, index) => (
//                 <tr
//                   key={t.id}
//                   style={index % 2 === 0 ? styles.row : styles.rowAlternate}
//                   onMouseOver={(e) =>
//                     (e.currentTarget.style.backgroundColor =
//                       styles.rowHover.backgroundColor)
//                   }
//                   onMouseOut={(e) =>
//                     (e.currentTarget.style.backgroundColor =
//                       index % 2 === 0
//                         ? styles.row.backgroundColor
//                         : styles.rowAlternate.backgroundColor)
//                   }
//                 >
//                   <td style={styles.td}>{t.id}</td>
//                   <td style={styles.td}>{t.filename || "—"}</td>
//                   <td style={styles.td}>
//                     <span
//                       style={{
//                         ...styles.actionTag,
//                         ...(t.action_type === "sent"
//                           ? styles.actionSent
//                           : styles.actionReceived),
//                       }}
//                     >
//                       {t.action_type}
//                     </span>
//                   </td>
//                   <td style={styles.td}>{t.ip_address || "—"}</td>
//                   {/* <td style={styles.td}>{new Date(t.timestamp).toLocaleString()}</td> */}
//                   <td style={styles.td}>
//                     {new Date(t.timestamp).toLocaleString("en-IN", {
//                       timeZone: "Asia/Kolkata",
//                       year: "numeric",
//                       month: "2-digit",
//                       day: "2-digit",
//                       hour: "2-digit",
//                       minute: "2-digit",
//                       second: "2-digit",
//                     })}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="5" style={styles.empty}>
//                   No transactions yet
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//       {error && <p style={styles.error}>{error}</p>}
//     </div>
//   );
// }

// export default Transactions;

// mobile responsive version

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// function Transactions() {
//   const [transactions, setTransactions] = useState([]);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchTransactions = async () => {
//       const token = localStorage.getItem("token");
//       try {
//         const res = await axios.get(`${API_BASE_URL}/transactions`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         setTransactions(res.data);
//         setError("");
//       } catch (err) {
//         setError(err.response?.data?.error || "Failed to fetch transactions");
//       }
//     };
//     fetchTransactions();
//   }, []);

//   const styles = {
//     container: {
//       padding: "50px",
//       backgroundColor: "#f4f4f9",
//       minHeight: "100vh",
//       marginLeft: "220px",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#333",
//       marginBottom: "20px",
//       display: "flex",
//       alignItems: "center",
//     },
//     icon: {
//       fontSize: "28px",
//       marginRight: "8px",
//     },
//     tableContainer: {
//       backgroundColor: "#fff",
//       borderRadius: "8px",
//       boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//       overflow: "auto",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//       minWidth: "700px",
//     },
//     th: {
//       padding: "12px",
//       textAlign: "left",
//       fontSize: "12px",
//       fontWeight: "600",
//       color: "#666",
//       backgroundColor: "#f8f8f8",
//       borderBottom: "2px solid #e0e0e0",
//       textTransform: "uppercase",
//     },
//     td: {
//       padding: "12px",
//       color: "#333",
//       borderBottom: "1px solid #e0e0e0",
//     },
//     row: {
//       backgroundColor: "#fff",
//     },
//     rowAlternate: {
//       backgroundColor: "#f9f9f9",
//     },
//     rowHover: {
//       backgroundColor: "#f0f0f0",
//     },
//     actionTag: {
//       display: "inline-block",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "12px",
//       fontWeight: "500",
//     },
//     actionSent: {
//       backgroundColor: "#e6f3ff",
//       color: "#1e88e5",
//     },
//     actionReceived: {
//       backgroundColor: "#e6ffed",
//       color: "#2e7d32",
//     },
//     empty: {
//       padding: "40px",
//       textAlign: "center",
//       color: "#666",
//       fontSize: "16px",
//     },
//     error: {
//       marginTop: "15px",
//       color: "#e53e3e",
//       fontSize: "14px",
//     },
//   };

//   return (
//     <>
//       <style>
//         {`
//           @media (max-width: 768px) {
//             .transactions-container {
//               margin-left: 0 !important;
//               padding: 15px !important;
//             }
            
//             .transactions-heading {
//               font-size: 20px !important;
//               margin-top: 50px !important;
//             }
            
//             .transactions-table-container {
//               overflow-x: auto !important;
//             }
            
//             .transactions-table {
//               font-size: 12px !important;
//             }
            
//             .transactions-th {
//               padding: 10px !important;
//               font-size: 11px !important;
//             }
            
//             .transactions-td {
//               padding: 10px !important;
//             }
            
//             .action-tag {
//               font-size: 11px !important;
//               padding: 3px 6px !important;
//             }
//           }

//           @media (max-width: 480px) {
//             .transactions-container {
//               padding: 12px !important;
//             }
            
//             .transactions-heading {
//               font-size: 18px !important;
//             }
            
//             .transactions-table {
//               font-size: 11px !important;
//             }
            
//             .transactions-th {
//               padding: 8px !important;
//               font-size: 10px !important;
//             }
            
//             .transactions-td {
//               padding: 8px !important;
//             }
            
//             .transactions-icon {
//               font-size: 22px !important;
//             }
//           }
//         `}
//       </style>
//       <div className="transactions-container" style={styles.container}>
//         <h2 className="transactions-heading" style={styles.heading}>
//           <span className="transactions-icon" style={styles.icon}>🔄</span> Transactions
//         </h2>
//         <div className="transactions-table-container" style={styles.tableContainer}>
//           <table className="transactions-table" style={styles.table}>
//             <thead>
//               <tr>
//                 <th className="transactions-th" style={styles.th}>ID</th>
//                 <th className="transactions-th" style={styles.th}>File Name</th>
//                 <th className="transactions-th" style={styles.th}>Action</th>
//                 <th className="transactions-th" style={styles.th}>IP Address</th>
//                 <th className="transactions-th" style={styles.th}>Timestamp</th>
//               </tr>
//             </thead>
//             <tbody>
//               {transactions.length > 0 ? (
//                 transactions.map((t, index) => (
//                   <tr
//                     key={t.id}
//                     style={index % 2 === 0 ? styles.row : styles.rowAlternate}
//                     onMouseOver={(e) =>
//                       (e.currentTarget.style.backgroundColor =
//                         styles.rowHover.backgroundColor)
//                     }
//                     onMouseOut={(e) =>
//                       (e.currentTarget.style.backgroundColor =
//                         index % 2 === 0
//                           ? styles.row.backgroundColor
//                           : styles.rowAlternate.backgroundColor)
//                     }
//                   >
//                     <td className="transactions-td" style={styles.td}>{t.id}</td>
//                     <td className="transactions-td" style={styles.td}>{t.filename || "—"}</td>
//                     <td className="transactions-td" style={styles.td}>
//                       <span
//                         className="action-tag"
//                         style={{
//                           ...styles.actionTag,
//                           ...(t.action_type === "sent"
//                             ? styles.actionSent
//                             : styles.actionReceived),
//                         }}
//                       >
//                         {t.action_type}
//                       </span>
//                     </td>
//                     <td className="transactions-td" style={styles.td}>{t.ip_address || "—"}</td>
//                     <td className="transactions-td" style={styles.td}>
//                       {new Date(t.timestamp).toLocaleString("en-IN", {
//                         timeZone: "Asia/Kolkata",
//                         year: "numeric",
//                         month: "2-digit",
//                         day: "2-digit",
//                         hour: "2-digit",
//                         minute: "2-digit",
//                         second: "2-digit",
//                       })}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" style={styles.empty}>
//                     No transactions yet
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//         {error && <p style={styles.error}>{error}</p>}
//       </div>
//     </>
//   );
// }

// export default Transactions;





// paginated and responsive StoredFiles Component---table scrool no  responsive
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// function Transactions() {
//   const [transactions, setTransactions] = useState([]);
//   const [error, setError] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const transactionsPerPage = 5;

//   useEffect(() => {
//     const fetchTransactions = async () => {
//       const token = localStorage.getItem("token");
//       try {
//         const res = await axios.get(`${API_BASE_URL}/transactions`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         // ✅ remove duplicates by (id + action_type)
//         const uniqueTransactions = res.data.filter(
//           (v, i, a) =>
//             a.findIndex(
//               (t) => t.id === v.id && t.action_type === v.action_type
//             ) === i
//         );

//         setTransactions(uniqueTransactions);
//         setError("");
//       } catch (err) {
//         setError(err.response?.data?.error || "Failed to fetch transactions");
//       }
//     };
//     fetchTransactions();
//   }, []);

//   // Pagination logic
//   const indexOfLast = currentPage * transactionsPerPage;
//   const indexOfFirst = indexOfLast - transactionsPerPage;
//   const currentTransactions = transactions.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(transactions.length / transactionsPerPage);

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const styles = {
//     container: {
//       padding: "50px",
//       backgroundColor: "#f4f4f9",
//       minHeight: "100vh",
//       marginLeft: "220px",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#333",
//       marginBottom: "20px",
//       display: "flex",
//       alignItems: "center",
//     },
//     icon: {
//       fontSize: "28px",
//       marginRight: "8px",
//     },
//     tableContainer: {
//       backgroundColor: "#fff",
//       borderRadius: "8px",
//       boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//       overflow: "auto",
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//       minWidth: "700px",
//     },
//     th: {
//       padding: "12px",
//       textAlign: "left",
//       fontSize: "12px",
//       fontWeight: "600",
//       color: "#666",
//       backgroundColor: "#f8f8f8",
//       borderBottom: "2px solid #e0e0e0",
//       textTransform: "uppercase",
//     },
//     td: {
//       padding: "12px",
//       color: "#333",
//       borderBottom: "1px solid #e0e0e0",
//     },
//     row: {
//       backgroundColor: "#fff",
//     },
//     rowAlternate: {
//       backgroundColor: "#f9f9f9",
//     },
//     rowHover: {
//       backgroundColor: "#f0f0f0",
//     },
//     actionTag: {
//       display: "inline-block",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "12px",
//       fontWeight: "500",
//     },
//     actionSent: {
//       backgroundColor: "#e6f3ff",
//       color: "#1e88e5",
//     },
//     actionReceived: {
//       backgroundColor: "#e6ffed",
//       color: "#2e7d32",
//     },
//     empty: {
//       padding: "40px",
//       textAlign: "center",
//       color: "#666",
//       fontSize: "16px",
//     },
//     error: {
//       marginTop: "15px",
//       color: "#e53e3e",
//       fontSize: "14px",
//     },
//     pagination: {
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       marginTop: "20px",
//       gap: "10px",
//       flexWrap: "wrap",
//     },
//     pageButton: {
//       padding: "8px 14px",
//       border: "1px solid #ccc",
//       borderRadius: "5px",
//       backgroundColor: "#fff",
//       cursor: "pointer",
//       fontSize: "14px",
//       color: "#333",
//       transition: "all 0.2s ease",
//     },
//     activePage: {
//       backgroundColor: "#007bff",
//       color: "#fff",
//       borderColor: "#007bff",
//     },
//     disabledButton: {
//       opacity: 0.5,
//       cursor: "not-allowed",
//     },
//   };

//   return (
//     <>
//       <style>
//         {`
//           @media (max-width: 768px) {
//             .transactions-container {
//               margin-left: 0 !important;
//               padding: 15px !important;
//             }
//             .transactions-heading {
//               font-size: 20px !important;
//               margin-top: 50px !important;
//             }
//             .transactions-table-container {
//               overflow-x: auto !important;
//             }
//             .transactions-table {
//               font-size: 12px !important;
//             }
//             .transactions-th {
//               padding: 10px !important;
//               font-size: 11px !important;
//             }
//             .transactions-td {
//               padding: 10px !important;
//             }
//             .action-tag {
//               font-size: 11px !important;
//               padding: 3px 6px !important;
//             }
//           }
//           @media (max-width: 480px) {
//             .transactions-container {
//               padding: 12px !important;
//             }
//             .transactions-heading {
//               font-size: 18px !important;
//             }
//             .transactions-table {
//               font-size: 11px !important;
//             }
//             .transactions-th {
//               padding: 8px !important;
//               font-size: 10px !important;
//             }
//             .transactions-td {
//               padding: 8px !important;
//             }
//             .transactions-icon {
//               font-size: 22px !important;
//             }
//           }
//         `}
//       </style>

//       <div className="transactions-container" style={styles.container}>
//         <h2 className="transactions-heading" style={styles.heading}>
//           <span className="transactions-icon" style={styles.icon}>🔄</span>{" "}
//           Transactions
//         </h2>

//         <div
//           className="transactions-table-container"
//           style={styles.tableContainer}
//         >
//           <table className="transactions-table" style={styles.table}>
//             <thead>
//               <tr>
//                 <th className="transactions-th" style={styles.th}>ID</th>
//                 <th className="transactions-th" style={styles.th}>File Name</th>
//                 <th className="transactions-th" style={styles.th}>Action</th>
//                 <th className="transactions-th" style={styles.th}>IP Address</th>
//                 <th className="transactions-th" style={styles.th}>Timestamp</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentTransactions.length > 0 ? (
//                 currentTransactions.map((t, index) => (
//                   <tr
//                     key={`${t.id}-${t.action_type}`}
//                     style={
//                       index % 2 === 0 ? styles.row : styles.rowAlternate
//                     }
//                     onMouseOver={(e) =>
//                       (e.currentTarget.style.backgroundColor =
//                         styles.rowHover.backgroundColor)
//                     }
//                     onMouseOut={(e) =>
//                       (e.currentTarget.style.backgroundColor =
//                         index % 2 === 0
//                           ? styles.row.backgroundColor
//                           : styles.rowAlternate.backgroundColor)
//                     }
//                   >
//                     <td className="transactions-td" style={styles.td}>{t.id}</td>
//                     <td className="transactions-td" style={styles.td}>{t.filename || "—"}</td>
//                     <td className="transactions-td" style={styles.td}>
//                       <span
//                         className="action-tag"
//                         style={{
//                           ...styles.actionTag,
//                           ...(t.action_type === "sent"
//                             ? styles.actionSent
//                             : styles.actionReceived),
//                         }}
//                       >
//                         {t.action_type}
//                       </span>
//                     </td>
//                     <td className="transactions-td" style={styles.td}>{t.ip_address || "—"}</td>
//                     <td className="transactions-td" style={styles.td}>
//                       {new Date(t.timestamp).toLocaleString("en-IN", {
//                         timeZone: "Asia/Kolkata",
//                         year: "numeric",
//                         month: "2-digit",
//                         day: "2-digit",
//                         hour: "2-digit",
//                         minute: "2-digit",
//                         second: "2-digit",
//                       })}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" style={styles.empty}>
//                     No transactions yet
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {transactions.length > transactionsPerPage && (
//           <div style={styles.pagination}>
//             <button
//               style={{
//                 ...styles.pageButton,
//                 ...(currentPage === 1 ? styles.disabledButton : {}),
//               }}
//               disabled={currentPage === 1}
//               onClick={() => handlePageChange(currentPage - 1)}
//             >
//               ◀ Prev
//             </button>

//             {Array.from({ length: totalPages }, (_, index) => (
//               <button
//                 key={index}
//                 style={{
//                   ...styles.pageButton,
//                   ...(currentPage === index + 1 ? styles.activePage : {}),
//                 }}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </button>
//             ))}

//             <button
//               style={{
//                 ...styles.pageButton,
//                 ...(currentPage === totalPages ? styles.disabledButton : {}),
//               }}
//               disabled={currentPage === totalPages}
//               onClick={() => handlePageChange(currentPage + 1)}
//             >
//               Next ▶
//             </button>
//           </div>
//         )}

//         {error && <p style={styles.error}>{error}</p>}
//       </div>
//     </>
//   );
// }

// export default Transactions;






import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";

function Transactions() {
  const [transactions, setTransactions] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const transactionsPerPage = 5;

  useEffect(() => {
    const fetchTransactions = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get(`${API_BASE_URL}/transactions`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // ✅ remove duplicates by (id + action_type)
        const uniqueTransactions = res.data.filter(
          (v, i, a) =>
            a.findIndex(
              (t) => t.id === v.id && t.action_type === v.action_type
            ) === i
        );

        setTransactions(uniqueTransactions);
        setError("");
      } catch (err) {
        setError(err.response?.data?.error || "Failed to fetch transactions");
      }
    };
    fetchTransactions();
  }, []);

  // Pagination logic
  const indexOfLast = currentPage * transactionsPerPage;
  const indexOfFirst = indexOfLast - transactionsPerPage;
  const currentTransactions = transactions.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(transactions.length / transactionsPerPage);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // Format date based on screen size
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      // Show only date on mobile
      return date.toLocaleDateString("en-IN", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    } else {
      // Show full date and time on desktop
      return date.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    }
  };

  const styles = {
    container: {
      padding: "50px",
      backgroundColor: "#f4f4f9",
      minHeight: "100vh",
      marginLeft: "220px",
      maxWidth: "100%",
      overflowX: "hidden",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "20px",
      display: "flex",
      alignItems: "center",
    },
    icon: {
      fontSize: "28px",
      marginRight: "8px",
    },
    tableContainer: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      overflowX: "auto",
      overflowY: "visible",
      WebkitOverflowScrolling: "touch",
      maxWidth: "100%",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "700px",
    },
    th: {
      padding: "12px",
      textAlign: "left",
      fontSize: "12px",
      fontWeight: "600",
      color: "#666",
      backgroundColor: "#f8f8f8",
      borderBottom: "2px solid #e0e0e0",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
    },
    td: {
      padding: "12px",
      color: "#333",
      borderBottom: "1px solid #e0e0e0",
      whiteSpace: "nowrap",
    },
    row: {
      backgroundColor: "#fff",
    },
    rowAlternate: {
      backgroundColor: "#f9f9f9",
    },
    rowHover: {
      backgroundColor: "#f0f0f0",
    },
    actionTag: {
      display: "inline-block",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: "500",
    },
    actionSent: {
      backgroundColor: "#e6f3ff",
      color: "#1e88e5",
    },
    actionReceived: {
      backgroundColor: "#e6ffed",
      color: "#2e7d32",
    },
    empty: {
      padding: "40px",
      textAlign: "center",
      color: "#666",
      fontSize: "16px",
      whiteSpace: "normal",
    },
    error: {
      marginTop: "15px",
      color: "#e53e3e",
      fontSize: "14px",
    },
    pagination: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "20px",
      gap: "10px",
      flexWrap: "wrap",
    },
    pageButton: {
      padding: "8px 14px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      backgroundColor: "#fff",
      cursor: "pointer",
      fontSize: "14px",
      color: "#333",
      transition: "all 0.2s ease",
    },
    activePage: {
      backgroundColor: "#007bff",
      color: "#fff",
      borderColor: "#007bff",
    },
    disabledButton: {
      opacity: 0.5,
      cursor: "not-allowed",
    },
  };

  return (
    <>
      <style>
        {`
          /* Prevent body/html horizontal scroll */
          html, body {
            overflow-x: hidden !important;
            max-width: 100vw !important;
          }
          
          /* Container should not scroll horizontally */
          .transactions-container {
            overflow-x: hidden !important;
            max-width: 100% !important;
          }
          
          /* Only table container scrolls */
          .transactions-table-container {
            overflow-x: auto !important;
            overflow-y: visible !important;
            -webkit-overflow-scrolling: touch;
            max-width: 100% !important;
            width: 100% !important;
          }
          
          .transactions-table-container::-webkit-scrollbar {
            height: 8px;
          }
          
          .transactions-table-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
          }
          
          .transactions-table-container::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;
          }
          
          .transactions-table-container::-webkit-scrollbar-thumb:hover {
            background: #555;
          }

          @media (max-width: 768px) {
            .transactions-container {
              margin-left: 0 !important;
              padding: 15px !important;
              overflow-x: hidden !important;
              max-width: 100vw !important;
            }
            .transactions-heading {
              font-size: 20px !important;
              margin-top: 50px !important;
            }
            .transactions-table {
              font-size: 12px !important;
            }
            .transactions-th {
              padding: 10px !important;
              font-size: 11px !important;
            }
            .transactions-td {
              padding: 10px !important;
            }
            .action-tag {
              font-size: 11px !important;
              padding: 3px 6px !important;
            }
          }
          @media (max-width: 480px) {
            .transactions-container {
              padding: 12px !important;
              overflow-x: hidden !important;
              max-width: 100vw !important;
            }
            .transactions-heading {
              font-size: 18px !important;
            }
            .transactions-table {
              font-size: 11px !important;
            }
            .transactions-th {
              padding: 8px !important;
              font-size: 10px !important;
            }
            .transactions-td {
              padding: 8px !important;
            }
            .transactions-icon {
              font-size: 22px !important;
            }
          }
        `}
      </style>

      <div className="transactions-container" style={styles.container}>
        <h2 className="transactions-heading" style={styles.heading}>
          <span className="transactions-icon" style={styles.icon}>🔄</span>{" "}
          Transactions
        </h2>

        <div
          className="transactions-table-container"
          style={styles.tableContainer}
        >
          <table className="transactions-table" style={styles.table}>
            <thead>
              <tr>
                <th className="transactions-th" style={styles.th}>ID</th>
                <th className="transactions-th" style={styles.th}>File Name</th>
                <th className="transactions-th" style={styles.th}>Action</th>
                <th className="transactions-th" style={styles.th}>IP Address</th>
                <th className="transactions-th" style={styles.th}>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              {currentTransactions.length > 0 ? (
                currentTransactions.map((t, index) => (
                  <tr
                    key={`${t.id}-${t.action_type}`}
                    style={
                      index % 2 === 0 ? styles.row : styles.rowAlternate
                    }
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        styles.rowHover.backgroundColor)
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        index % 2 === 0
                          ? styles.row.backgroundColor
                          : styles.rowAlternate.backgroundColor)
                    }
                  >
                    <td className="transactions-td" style={styles.td}>{t.id}</td>
                    <td className="transactions-td" style={styles.td}>{t.filename || "—"}</td>
                    <td className="transactions-td" style={styles.td}>
                      <span
                        className="action-tag"
                        style={{
                          ...styles.actionTag,
                          ...(t.action_type === "sent"
                            ? styles.actionSent
                            : styles.actionReceived),
                        }}
                      >
                        {t.action_type}
                      </span>
                    </td>
                    <td className="transactions-td" style={styles.td}>{t.ip_address || "—"}</td>
                    <td className="transactions-td" style={styles.td}>
                      {formatDate(t.timestamp)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={styles.empty}>
                    No transactions yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {transactions.length > transactionsPerPage && (
          <div style={styles.pagination}>
            <button
              style={{
                ...styles.pageButton,
                ...(currentPage === 1 ? styles.disabledButton : {}),
              }}
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              ◀ Prev
            </button>

            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                style={{
                  ...styles.pageButton,
                  ...(currentPage === index + 1 ? styles.activePage : {}),
                }}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </button>
            ))}

            <button
              style={{
                ...styles.pageButton,
                ...(currentPage === totalPages ? styles.disabledButton : {}),
              }}
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next ▶
            </button>
          </div>
        )}

        {error && <p style={styles.error}>{error}</p>}
      </div>
    </>
  );
}

export default Transactions;
